<template>
    <li class="nav-item dropdown d-flex align-items-center pe-2">
        <a id="dropdownMenuButton" href="#" class="p-0 nav-link text-body" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="d-sm-inline d-none me-sm-2">{{ customer.name }}</span>
            <i class="fa fa-user-circle" aria-hidden="true"></i>
        </a>
        <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" aria-labelledby="dropdownMenuButton">
            <li>
                <button class="dropdown-item border-radius-md" type="button">
                    <span class="btn-inner--icon">
                      <i class="fa fa-user-circle me-3"></i>
                    </span>
                    <span v-if="userData" class="btn-inner--text">{{ userData.user }}</span>
                </button>
            </li>
            <li>
                <button class="dropdown-item border-radius-md text-primary"  type="button" data-bs-toggle="modal" data-bs-target="#changepassword">
                    <span class="btn-inner--icon">
                      <i class="fa fa-solid fa-key text-primary me-3"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_change_password') }}</span>
                </button>
            </li>
            <hr v-if="$Permission.isInternalUser() || $Permission.isInternalAdmin()" class="horizontal my-2" />
            <li v-if="$Permission.isInternalUser() || $Permission.isInternalAdmin()">
                <button class="dropdown-item border-radius-md text-primary"  type="button" data-bs-toggle="modal" data-bs-target="#changeBrand">
                    <span class="btn-inner--icon">
                      <i class="fa fa-solid fa-key text-primary me-3"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_change_brand') }}</span>
                </button>
            </li>
            <hr class="horizontal my-2" />
            <li>
                <button class="dropdown-item border-radius-md text-danger"  type="button" @click="logout()">
                    <span class="btn-inner--icon">
                      <i class="fa fa-solid fa-arrow-right-from-bracket text-danger me-3"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_logout') }}</span>
                </button>
            </li>
        </ul>
    </li>
</template>

<script>

    import { mapActions } from "vuex";
    import { stopCrataWidget } from "@/plugins/CrataWidget";

    export default {
        name: "UserMenu",
        props: {
            userData: {
                type: Object,
                default: null,
            },
            customer: {
                type: Object,
                default: null,
            },
        },
        
        methods: {
            ...mapActions("user", ["logout"]),
            logout() {
                stopCrataWidget();
                localStorage.removeItem("user");
                this.$router.push({ name: "Login page" });
            }
        }
    };

</script>